module.exports = __webpack_public_path__ + "static/img/Slide-Serv-1.72a9284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Slide-Serv-1.png
// module id = oTfO
// module chunks = 0